import React, {useRef, useState} from "react";
import {
    AppBar,
    Divider,
    Grid,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {AccountCircle, Logout,} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {PROFILE} from "../../AppRoutes";
import {UserTranslKey} from "../user/UserTranslKey";
import {useAuth} from "../../auth/AuthContext";
import {formatUserFirstNameFirst} from "../user/UserFormatter";
import {useUser} from "../user/UserContext";
import {AppBarIconButton} from "@dain/mui-components";
import {EnvConfiguration} from "../../EnvConfig";
import MainHeader from "./MainHeader";
import {useNavigate} from "react-router-dom";

export default function MainMenu() {
    const [userProfileElement, setUserProfileElement] = useState<Element | null>(
        null
    );
    const userMenuOpen = Boolean(userProfileElement);

    const navigate = useNavigate();
    const {t} = useTranslation();
    const {authClient} = useAuth();
    const user = useUser();

    const envConfig = useRef(EnvConfiguration.getConfig());

    const theme = useTheme();
    const smAndBiggerScreen: boolean = useMediaQuery(theme.breakpoints.up("sm"));

    function logout() {
        authClient?.logout({redirectUri: envConfig.current.portalUrl});
    }

    function onUserProfileClick() {
        navigate(PROFILE);
        setUserProfileElement(null);
    }

    return (
        <>
            <MainHeader>
                <Grid item xs={"auto"}>
                    <AppBarIconButton onClick={(event) => setUserProfileElement(event.currentTarget)}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            {smAndBiggerScreen && <Typography>{formatUserFirstNameFirst(user)}</Typography>}
                            <AccountCircle/>
                        </Stack>
                    </AppBarIconButton>
                </Grid>
            </MainHeader>

            <AppBar position={"static"}>
                <Menu open={userMenuOpen}
                        onClose={() => setUserProfileElement(null)}
                        anchorEl={userProfileElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                        transformOrigin={{horizontal: 'right', vertical: 'top'}} >
                    <MenuItem onClick={onUserProfileClick}>
                        <ListItemIcon>
                            <AccountCircle/>
                        </ListItemIcon>
                        <ListItemText>{t(UserTranslKey.PROFILE)}</ListItemText>
                    </MenuItem>
                    <Divider/>
                    <MenuItem onClick={logout}>
                        <ListItemIcon>
                            <Logout/>
                        </ListItemIcon>
                        <ListItemText>{t(UserTranslKey.LOGOUT)}</ListItemText>
                    </MenuItem>
                </Menu>
            </AppBar>
        </>
    );
}
